<template>
  <GmapMap
    ref="map"
    :center="center"
    :zoom="12"
    map-type-id="hybrid"
    :style="{
      width: '100%',
      height: xsOnly ? '300px' : '450px',
      'border-radius': smAndDown ? '0' : '8px',
      overflow: 'hidden',
    }"
  >
    <GmapPolygon
      v-for="(item, index) in coordinates"
      :key="index"
      :paths="convertCoordinates(item.coordinates)"
      :options="polygonOptions"
    ></GmapPolygon>

    <GmapPolygon :paths="polygonPath" :options="polygonOptions"></GmapPolygon>
  </GmapMap>
</template>

<script>
import { polygonOptions } from "@/utils/polygonOptions";

export default {
  props: {
    coordinates: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      center: {},
      polygonPath: [],
      polygonOptions,
    };
  },
  computed: {
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.fitMapToPolygons();
    });
  },
  methods: {
    async fitMapToPolygons() {
      await this.$gmapApiPromiseLazy();

      const bounds = new google.maps.LatLngBounds();
      let hasPoints = false;

      this.coordinates.forEach((item) => {
        if (!item?.coordinates?.coordinates?.length) return;

        const coords = item.coordinates.coordinates[0];

        coords.forEach((coord) => {
          const lng = Number(coord[0]);
          const lat = Number(coord[1]);

          if (isNaN(lat) || isNaN(lng)) return;

          bounds.extend({ lat, lng });
          hasPoints = true;
        });
      });

      if (!hasPoints) return;

      const map = this.$refs.map.$mapObject;

      map.fitBounds(bounds);

      const center = bounds.getCenter();

      this.center = {
        lat: center.lat(),
        lng: center.lng(),
      };
    },
    convertCoordinates(coordinates) {
      const polygonCoordinates = coordinates.coordinates[0];

      return polygonCoordinates.map((coord) => ({
        lat: coord[1],
        lng: coord[0],
      }));
    },
  },
};
</script>
